import stlFile from '../dataMapping/stlFile'

const calculateHeight = (stl) => {
  const vertices = stlFile(stl)
  let minY = Infinity
  let maxY = -Infinity

  let minZ = Infinity
  let maxZ = -Infinity

  vertices.forEach((vertex) => {
    const y = vertex[1]
    const z = vertex[2]
    minY = Math.min(minY, y)
    maxY = Math.max(maxY, y)
    minZ = Math.min(minZ, z)
    maxZ = Math.max(maxZ, z)
  })
  console.log(maxZ - minZ, maxZ, minZ, 'maxZ - minZ')
  return { y: maxY - minY, z: maxZ - minZ }
}

export default calculateHeight
